import React, { createContext, useContext, useEffect, useState } from "react";

const OpprtunityContext = createContext();

export default function OpprtunityContextProvider({ children }) {
  const [idValue, setIdValue] = useState(null);

  return (
    <OpprtunityContext.Provider value={{ idValue, setIdValue }}>
      {children}
    </OpprtunityContext.Provider>
  );
}

export const useOppurtunityId = () => {
  return useContext(OpprtunityContext);
};
